import React from 'react';
import { useSelector } from 'react-redux';

import SettingsIcon from '@mui/icons-material/Settings';

import {
  Grid,
  Typography,
} from '@mui/material';

import AvatarWithStatus from './AvatarWithStatus';
import { currentContactSelector } from '../nfChatSlice';
import { useGetContactsQuery } from 'app/features/chat/chatApi';

import {
  useGetAdvisorsQuery,
  useGetAppConfigQuery,
} from 'app/api/mainApi';

const ContactBarContainer = () => {
  const currentContact = useSelector(currentContactSelector);
  const currentUser = useGetAppConfigQuery().data?.current_user;
  const { data: contactsData } = useGetContactsQuery();

  // the next bunch of lines can probably be abstracted, it's also used in
  // ContactListContainer.jsx, so either put it in the hook, or save the current
  // advisor in the redux store along with the current contact. not sure which
  // way I prefer yet
  let advisorIds = [];
  if (!currentUser?.is_advisor && contactsData) {
    advisorIds = contactsData.contacts.map((contact) => contact.other_user.id);
  }

  const { data: advisors } = useGetAdvisorsQuery({ ids: advisorIds }, {
    skip: !currentUser || currentUser.is_advisor || !advisorIds.length,
  });

  let advisor;
  if (!currentUser.is_advisor && advisors) {
    advisor = advisors.find((advisor) => {
      return advisor.id === currentContact?.other_user.id;
    });
  }

  return (
    <Grid
      className="contact-bar"
      container
      sx={{
        backgroundColor: 'rgb(245, 245, 254)',
        padding: '10px 30px',
        alignItems: 'center',
        marginTop: '12px',
        width: '100%',
      }}
    >
      <Grid item xs="auto">
        <AvatarWithStatus contact={currentContact} advisor={advisor} />
      </Grid>
      <Grid item xs>
        <Typography variant="h6" sx={{ paddingLeft: 1.5 }}>
          {currentContact?.other_user.name}
        </Typography>
      </Grid>
      <Grid item xs="auto" sx={{ textAlign: 'right' }}>
        <SettingsIcon />
      </Grid>
    </Grid>
  );
};

export default ContactBarContainer;
